import { Component } from '@angular/core';
import { B2BUser, TranslatePipe } from '@spartacus/core';
import { BaseItem, ToggleStatusComponent } from '@spartacus/organization/administration/components';
import { ICON_TYPE } from '../../model/user-profiles-icon.model';
import { IconComponent } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-efa-toggle-status',
    templateUrl: './efa-toggle-status.component.html',
    host: { class: 'content-wrapper' },
    imports: [IconComponent, AsyncPipe, TranslatePipe]
})
export class EfaToggleStatusComponent<T extends BaseItem> extends ToggleStatusComponent<T> {
  iconTypes = ICON_TYPE;
  protected getPatchedItem(item: T): T {
    const patch: BaseItem = {};
    patch[this.key] = item[this.key];
    patch.orgUnit = item.orgUnit;
    patch['email'] = (item as B2BUser).email;
    patch.active = !item.active;
    patch['portalUser'] = (item as B2BUser).portalUser;
    patch['uid'] = item.uid;
    return patch as T;
  }
}
